
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';
import { WorkMailSendingProviderEnum } from '../models/work-mail-sending-provider-enum';
import { WorkMailSenderSmtpSettingsDto } from '../models/work-mail-sender-smtp-settings-dto';
import { WorkMailSenderGoogleSettingsDto } from '../models/work-mail-sender-google-settings-dto';
import { WorkMailSenderOffice365SettingsDto } from '../models/work-mail-sender-office-365-settings-dto';
import { WorkMailSenderTechnicalSettingsDto } from '../models/work-mail-sender-technical-settings-dto';

export function getMailSenderProviderSettingsDtoFormGroup() {
return new FormGroup({
    activeProvider: new FormControl<WorkMailSendingProviderEnum | undefined>(undefined, [Validators.required]),
    defaultFromEmail: new FormControl<string | undefined>(undefined),
    defaultFromLabel: new FormControl<string | undefined>(undefined),
    technicalEmail: new FormControl<string | undefined>(undefined),
    smtp: new FormControl<WorkMailSenderSmtpSettingsDto | undefined>(undefined, [Validators.required]),
    google: new FormControl<WorkMailSenderGoogleSettingsDto | undefined>(undefined, [Validators.required]),
    office365: new FormControl<WorkMailSenderOffice365SettingsDto | undefined>(undefined, [Validators.required]),
    technical: new FormControl<WorkMailSenderTechnicalSettingsDto | undefined>(undefined, [Validators.required]),
})
;
}
      